exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .frames {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n\n:host .frame {\n  margin: 15px 5px; }\n\n:host .frame .price {\n    color: #9e0835;\n    font-weight: bold; }\n\n:host .more-info {\n  display: block;\n  margin: 15px 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/components/map-config-frame/map-config-frame.component.scss
// module id = ../../../../../src/app/components/map-config-frame/map-config-frame.component.scss
// module chunks = main